<template>
  <v-sheet>
    <v-toolbar
      class="toolbar-custom"
      :height="itemHeight"
      :class="{ current: isCurrent }"
      @click="nodeAction"
    >
      <v-btn v-if="!isLeaf" icon small>
        <v-icon small> fas fa-caret-{{ expanded ? "down" : "right" }} </v-icon>
      </v-btn>
      <OrganizationIcon v-else :organization="node" small class="ml-n1" />

      <div class="ml-2 d-flex flex-column">
        <span>{{ node.name }}</span>
      </div>

      <v-spacer />
    </v-toolbar>

    <div v-if="expanded && hasChildren" class="ml-4 subtree">
      <SideMenuOrgTree
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :leaf-type="leafType"
        :current-org-id="currentOrgId"
        @action="$listeners.action"
      />
    </div>
  </v-sheet>
</template>

<script>
import OrganizationIcon from "../utils/OrganizationIcon.vue";

// A self-recursive side-menu tree rendered from a PREBUILT hierarchy. Unlike
// OrganizationTree, it fetches nothing: children come straight from
// `node.children`, so it draws exactly the accessible scope (each permitted
// facility under its real organization/region path) with no over-broad
// descendant loads. Ancestor orgs/regions are context headers that only
// expand/collapse; only facility leaves are clickable and navigate.
export default {
  name: "SideMenuOrgTree",
  components: {
    OrganizationIcon,
  },
  props: {
    node: {
      type: Object,
      required: true,
    },
    leafType: {
      type: String,
      default: "facility",
    },
    currentOrgId: {
      type: String,
      default: "",
    },
  },
  data() {
    // Every node starts collapsed; the tree only opens where the user clicks, so
    // a deep, many-branch scope never unfolds on its own.
    return {
      expanded: false,
    };
  },
  computed: {
    isLeaf() {
      return this.node.type === this.leafType;
    },
    hasChildren() {
      return (this.node.children || []).length > 0;
    },
    isCurrent() {
      return this.currentOrgId && this.currentOrgId === this.node.id;
    },
    itemHeight() {
      return `${
        22 + // extra whitespace
        (1 + Math.floor(this.node.name.length / 22)) * 14 // number of rows * font size
      }px`;
    },
  },
  methods: {
    nodeAction() {
      if (this.isLeaf) {
        this.$emit("action", this.node);
      } else {
        this.expanded = !this.expanded;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar-custom {
  cursor: pointer;
  line-height: 1em;
  &::before {
    background-color: currentColor;
    opacity: 0;
    content: "";
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
  &:hover::before {
    opacity: 0.04;
  }
  &.current::before {
    opacity: 0.12;
  }
}
.subtree {
  border-left: 1px solid #0002;
}
</style>
